export class WishedSolution {
  CustomerProfile: boolean;
  WishedSolution: boolean;
  PeoplephoneSIPTRUNK: boolean;
  PeoplephoneHosted: boolean;
  NewPhoneNumbers: boolean;
  PhoneNumbersToBePorted: boolean;
  FlatRateSIPTRUNK: boolean;
  FlatRateHOSTED: boolean;
  PeoplephoneInternetIPworldcom: boolean;
  PeoplephoneInternetCyberlink: boolean;
  PeoplephoneDevicesDataBase: boolean;
  MyDevicesDataBase: boolean;
  OfferSummary: boolean;
  ThreeCX: boolean;
  MicrosoftTeams: boolean;
  PeoplefoneBundle: boolean;
  PeoplefoneMittel: boolean;
  Datasim: boolean;
  OperatorConnect: boolean;
  SBCplus: boolean;
  mobile: boolean;

  constructor() {
    this.CustomerProfile = true;
    this.WishedSolution = true;
    this.PeoplephoneSIPTRUNK = false;
    this.PeoplephoneHosted = false;
    this.NewPhoneNumbers = false;
    this.PhoneNumbersToBePorted = false;
    this.FlatRateSIPTRUNK = false;
    this.FlatRateHOSTED = false;
    this.PeoplephoneInternetIPworldcom = false;
    this.PeoplephoneInternetCyberlink = false;
    this.PeoplephoneDevicesDataBase = false;
    this.MyDevicesDataBase = false;
    this.MicrosoftTeams = false;
    this.ThreeCX = false;
    this.OfferSummary = true;
    this.PeoplefoneBundle = false;
    this.PeoplefoneMittel = false;
    this.Datasim = false;
    this.OperatorConnect = false;
    this.SBCplus = false;
    this.mobile = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/wishedSolution.ts